(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tutte-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tutte-product-video')) {
  customElements.define('tutte-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('.tutte-video__open');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.position = () => {
        let bottom = 0;
        document.querySelectorAll('.shopify-section-group-header-group, .header-wrapper').forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < innerHeight / 2) bottom = Math.max(bottom, rect.bottom);
        });
        this.style.setProperty('--tutte-video-top', `${Math.min(Math.max(bottom + 12, 16), Math.max(16, innerHeight - 160))}px`);
      };
      this.visibility = () => {
        if (document.hidden || this.dialog.open || this.motion.matches || this.hidden) this.preview?.pause();
        else this.preview?.play().catch(() => {});
        if (document.hidden) this.player?.pause();
      };
      this.openButton.addEventListener('click', () => {
        if (!this.player) {
          this.querySelector('.tutte-video__player').append(this.querySelector('.tutte-video__player-template').content.cloneNode(true));
          this.player = this.querySelector('.tutte-video__player video');
        }
        this.preview?.pause();
        this.dialog.showModal();
        this.player.play().catch(() => {});
      }, options);
      this.querySelector('.tutte-video__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, options);
      this.dialog.addEventListener('close', () => { this.player?.pause(); this.openButton.focus(); this.visibility(); }, options);
      this.querySelector('.tutte-video__dismiss').addEventListener('click', () => { this.hidden = true; this.preview?.pause(); }, options);
      window.addEventListener('resize', this.position, options);
      window.addEventListener('scroll', this.position, { ...options, passive: true });
      document.addEventListener('visibilitychange', this.visibility, options);
      this.motion.addEventListener('change', this.visibility, options);
      this.position();
      this.hidden = false;
      if (this.dataset.motion === 'true' && !this.motion.matches && !navigator.connection?.saveData) {
        this.openButton.prepend(this.querySelector('.tutte-video__preview-template').content.cloneNode(true));
        this.preview = this.querySelector('.tutte-video__preview');
        this.preview.setAttribute('aria-hidden', 'true');
        this.preview.setAttribute('tabindex', '-1');
        this.preview.muted = true;
        this.visibility();
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.preview?.pause();
      this.player?.pause();
      if (this.dialog?.open) this.dialog.close();
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
